import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CashFlowEstimation from './CashFlowEstimation';

const CashFlowEstimationRoutes = () => {
  return (
    <Routes>
      <Route index element={<CashFlowEstimation />} />
    </Routes>
  );
};

export default CashFlowEstimationRoutes;
